import type { PatternObject } from 'highcharts';
import type { CustomRow, HoldingsRowData, VennSeriesEntry, VennSeriesPieDataOptions } from 'venn-components';
import type { HoldingsCategoryInfo } from 'venn-state';
import { getHoldingsCategoryColor, type Theme, type VennColors } from 'venn-ui-kit';
import { assertNotNil, Numbers } from 'venn-utils';

// highcharts line pattern, see https://www.highcharts.com/docs/chart-design-and-style/pattern-fills
const linePattern = 'M 0 0 L 10 10 M 9 - 1 L 11 1 M - 1 9 L 1 11';

function getAssetAllocationRowData(
  customRow: CustomRow,
  categoriesData: { [key: string]: HoldingsCategoryInfo },
  colorPalette: VennColors,
): VennSeriesPieDataOptions[] {
  const row = customRow as HoldingsRowData;
  const { name } = categoriesData[row.id.id]!;
  const color = getHoldingsCategoryColor('', name ?? '', 'ASSET', 1, colorPalette);
  return [
    {
      name,
      legend: `${name} ${Numbers.safeFormatPercentage(row.allocation)}`,
      y: Math.abs(row.allocation),
      color:
        Math.sign(row.allocation) === 1
          ? color
          : ({
              pattern: {
                color,
                path: {
                  d: linePattern,
                  fill: '#000000',
                },
                width: 6,
                height: 6,
              },
            } as unknown as PatternObject),
    },
  ];
}

export function getAssetExposurePieChartSeries(
  theme: Theme,
  name: string,
  data?: CustomRow[],
  categoriesData?: { [key: string]: HoldingsCategoryInfo },
): VennSeriesEntry[] | undefined {
  return [
    {
      name,
      data: data
        ?.filter((row) => (row as HoldingsRowData).allocation)
        ?.flatMap((row) => getAssetAllocationRowData(row, assertNotNil(categoriesData), theme.Colors)),
    },
  ];
}
